jQuery( function( $ ) { // On Document Ready
	$( '.owl-carousel' ).owlCarousel( {

		itemsCustom: [
			[ 0, 1 ],
			[ 400, 1 ],
			[ 450, 2 ],
			[ 600, 2 ],
			[ 767, 2 ],
			[ 800, 3 ],
			[ 980, 3 ],
			[ 1024, 3 ],
			[ 1080, 4 ],
			[ 1200, 4 ],
			[ 1400, 4 ],
			[ 1600, 5 ],
			[ 2000, 6 ],
		],
		navigation: true,
		pagination: false,

	} );

	$( '#intro-newsroom .beta' ).fitVids();

	$( '#intro-newsroom .beta .overlay .playbtn' ).on( 'click', function() {
		let source = $( '#intro-newsroom .beta iframe' ).attr( 'src' );
		source     += '&autoplay=1';
		$( this ).parent().fadeOut( 100 );
		$( '#intro-newsroom .beta iframe' ).attr( 'src', source );
	} );

	// homepage intro, market image hover
	$( '#intro-img, #mkt-img' ).on( 'hover', function() {
		$( '#intro-img img, #mkt-img img' ).css( 'transform', 'scale(1.1)' );
	}, function() {
		$( '#intro-img img, #mkt-img img' ).css( 'transform', 'scale(1.0)' );
	} );
} ); // end document ready

//** ----------------------- BANNER ----------------------- **//

const sHeadline  = 0;
const SHeadline2 = 0;
const sProject   = 0;
let yOffset;

jQuery( window ).load( function() { // All items loaded
	const projectLink = $( '.slide-proj.cycle-slide-active .proj-details .link a' ).attr( 'href' );
	$( '#intro .link' ).html( '<a href="' + projectLink + '">View Project</a>' );
	yOffset           = $( '.slide-proj.cycle-slide-active .proj-details' ).outerHeight();

	$( '.owl-buttons .owl-prev' ).html( '<span data-icon="f"></span>' );
	$( '.owl-buttons .owl-next' ).html( '<span data-icon="g"></span>' );
} );

jQuery( window ).on( 'resize', function() { // On Window Resize
	yOffset = $( '.slide-proj.cycle-slide-active .proj-details' ).outerHeight();
} );

//** ------------------------ CYCLE ---------------------- **//

jQuery( document ).on( 'cycle-update-view', function() { // Banner Slider (Fires On Initiation + Transition)
	const projectLink = $( '.cycle-slideshow .slide-proj.cycle-slide-active .proj-details .link a' ).attr( 'href' ); // Get link for current project slide
	$( '#intro .link' ).html( '<a href="' + projectLink + '">View Project</a>' ); // Set on link outside of loop
} );

jQuery( document ).on( 'cycle-before', function() { // Banner Slider (Fires Before Slide Transition )
	$( '.cycle-slideshow .slide-proj.cycle-slide .proj-details' ).fadeOut( 'slow' ); // Fade out all slides
} );

jQuery( document ).on( 'cycle-after', function() { // Banner Slider (Fires After Slide Transition
	const width = $( window ).width();

	if ( width > 750 ) {
		$( '.cycle-slideshow .slide-proj.cycle-slide-active .proj-details' ).transition( { y: yOffset }, 0, 'snap' ); // Slide the details div down
		$( '.cycle-slideshow .slide-proj.cycle-slide-active .proj-details' ).fadeIn( 0 ); // Make the div visible
		$( '.cycle-slideshow .slide-proj.cycle-slide-active .proj-details' ).transition( { y: '0px' }, 450, 'ease' ); // Slide the details div up
	}
} );

//** --------------------- END BANNER ---------------------- **//

